export default "__VITE_ASSET__B92l0qC4__"